import { Reveal, Kicker } from "./Reveal";

const FUNDS = [
  ["Engineering & platform", 55],
  ["Design partners & GTM", 20],
  ["Compliance & security", 15],
  ["Operations", 10],
];

const FUNDS_LIST = [
  "Three design partners",
  "Published proof numbers",
  "Secure governed execution",
  "A repeatable pilot motion",
  "The evidence base for Series A",
];

export default function InvestorCTA() {
  return (
    <section className="border-b border-white/10" data-testid="investor-cta-section">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <div className="grid gap-16 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <Kicker index="13" label="Investors" />
            <h2 className="font-display text-4xl font-extrabold leading-[1.02] tracking-tighter sm:text-5xl" data-testid="investor-cta-heading">
              <span className="text-[#00FF41]">£2.5M seed</span> to turn governed pricing into proven
              Commercial Decision Infrastructure.
            </h2>
            <p className="mt-8 max-w-xl font-mono text-sm leading-relaxed text-zinc-400">
              The seed funds the transition from an existing platform to:
            </p>
            <div className="mt-6 space-y-0 max-w-xl">
              {FUNDS_LIST.map((f) => (
                <div key={f} className="border-b border-white/5 py-3 font-mono text-sm text-zinc-300 last:border-b-0">
                  <span className="mr-3 text-[#00FF41]">→</span>{f}
                </div>
              ))}
            </div>
            <div className="mt-10 flex flex-wrap items-center gap-6">
              <a
                href="/investor-briefing.pdf"
                download="Axiosera-Investor-Briefing.pdf"
                data-testid="investor-briefing-button"
                className="inline-block bg-[#00FF41] px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] text-black transition-colors duration-300 hover:bg-white"
              >
                Download the investor briefing ↓
              </a>
              <a
                href="mailto:sburke@axiosera.com?subject=Investor%20briefing%20request"
                data-testid="investor-email-link"
                className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-[#00FF41]"
              >
                or request by email →
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="border border-white/10 bg-[#0F0F11] p-10">
              <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">Use of funds</div>
              <div className="mt-8 space-y-6" data-testid="use-of-funds">
                {FUNDS.map(([label, pct]) => (
                  <div key={label}>
                    <div className="mb-2 flex justify-between font-mono text-xs">
                      <span className="text-zinc-400">{label}</span>
                      <span className="text-[#00FF41]">{pct}%</span>
                    </div>
                    <div className="h-1 w-full bg-white/5">
                      <div className="h-full bg-[#00FF41]/70" style={{ width: `${pct}%` }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
